/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_Simple_Fireant_GripInputs */

const fr_next_simple_fireant_grip = /** @type {(inputs: Next_Simple_Fireant_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cette séance ? Cette action est irréversible.`)
};

/**

* @param {Next_Simple_Fireant_GripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const next_simple_fireant_grip = /** @type {((inputs?: Next_Simple_Fireant_GripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_Simple_Fireant_GripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_next_simple_fireant_grip(inputs)
});